import React, {useEffect, useState} from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Container, Row, Col, Image ,Button } from 'react-bootstrap';
import { Link, useParams } from "react-router-dom";
import { Navigation } from 'swiper/modules';
import { Time, Calendar ,BtnArrow , StarIcon} from "../../svgIcon";
import "./_news-section.scss";
import "./_news-details-page.scss";
import CommonCrypt from "../../Common/CommonCrypt";
import Components from "../../Components";

function NewsDetails({ PageData, DetailRecord, Constant }) {
    const  route  = useParams();
    const APP_URL = window.site_url;
    const CDN_URL = window.cdn_path;
    const parsedDescription = DetailRecord ? DetailRecord : '';
    const [OtherNews,setOtherNews] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    let ImageWebp = '';
    if(DetailRecord?.varWebpImgURL){
        ImageWebp = CDN_URL+'caches/'+Constant?.NEWSTHUMB?.split(',')[2]?.replace('*','x')+'/'+DetailRecord?.varWebpImgURL;
    }else{
        ImageWebp = CDN_URL+'assets/images/'+DetailRecord?.varImgURL;
    }

    const formatDate = (date) => {
        return new Date(date).toLocaleString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        });
    };

    const formatTime = (date) => {
        return new Date(date).toLocaleString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    useEffect(()=>{
        const data = {
            'slug' : '',
            'limit' : 5
        }
        const fetChData = async () =>{
            const response = await fetch(APP_URL + `/api/news?ignoreid=${DetailRecord.id}`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
                });
            const news_data = await response.json();
            const newsDecrypted = JSON.parse(CommonCrypt(news_data.news_result));
            setOtherNews(newsDecrypted);
            setIsLoading(false);
        };

        fetChData();
    },[]);
    
    return (
           <>
                <section className="section-gap double-gap news-details" data-aos="fade">
                    <Container className="container">
                        <Row className="row justify-content-center">
                            <Col lg={12} className="text-center">
                                <h4 className="mb-3 title">{DetailRecord?.varTitle}</h4>
                                <ul className="list-unstyled mb-4 mb-lg-5 d-flex justify-content-center date-time flex-wrap">
                                    <li className="d-flex align-items-center"><span className="me-2"><i><Time/></i></span>{formatDate(DetailRecord?.dtDateTime)}.</li>
                                    <li className="d-flex align-items-center"><span className="me-2"><i><Calendar/></i></span>{formatTime(DetailRecord?.dtDateTime)}</li>
                                </ul>
                                <div className='thumbnail-container bg-transparent object-fit rounded-3'>
                                    <div className='thumbnail'>
                                        <Image src={ImageWebp} alt={DetailRecord?.varTitle} title={DetailRecord?.varTitle} width="100px" height="100px"  />
                                    </div>
                                </div>

                            </Col>
                            {DetailRecord?.txtDescription ? (
                                <Components PageData={parsedDescription} alias={route} Constant={Constant}/>
                                ) : (
                                <Col md={12} lg={9} className="cms mt-4 mt-md-5" ><p>{DetailRecord?.varShortDescription}</p></Col>
                            )}
                        </Row>
                    </Container>
                </section>

                {
                    isLoading ? (<>Loading ...</>) : (
                        <section className="news-section section-gap pt-4 pt-lg-5 pb-md-0 " data-aos="fade" data-aos-duration="1500">
                            <Container>
                                <Row>
                                    <Col xs={12}>
                                        <h2 className="sec-heading text-center mb-4 mb-md-5" data-aos="fade">
                                            <span className="ff-2">
                                                <span className="star">
                                                    <i className="blue" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                                                    <i className="red" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="300"><StarIcon/></i>
                                                    <i className="yellow" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                                                </span>
                                                <span data-aos="fade" data-aos-duration="1500" data-aos-delay="500">Related</span>
                                            </span>
                                            <span className="title-line" data-aos="fade" data-aos-duration="1500" data-aos-delay="500">
                                                <span>News</span>
                                            </span>
                                        </h2>
                                    </Col>

                                    <Col xs={12}>
                                        <div className="news-section-inner">
                                            <Swiper className="px-1 px-md-2"
                                                spaceBetween={30}
                                                navigation={{
                                                    nextEl: ".custom-next",
                                                    prevEl: ".custom-prev",
                                                }}
                                                modules={[Navigation]}
                                                breakpoints={{
                                                    1366: { slidesPerView: 3 },
                                                    992: { slidesPerView: 3 },
                                                    575: { slidesPerView: 2 },
                                                    460: { slidesPerView: 1.5 },
                                                    0: { slidesPerView: 1 },
                                                }}
                                            >
                                                {OtherNews?.news && OtherNews?.news?.data?.map((item) => {
                                                    let DetalPageUrl = '/'+OtherNews?.modulealias?.moduleAlias+'/'+item?.alias?.varAlias;
                                                    let firstImage = '';
                                                    if(item.varWebpImgURL){
                                                        firstImage = CDN_URL+'caches/'+Constant?.NEWSTHUMB?.split(',')[1]?.replace('*','x')+'/'+item?.varWebpImgURL;
                                                    }else{
                                                        firstImage = CDN_URL+'assets/images/'+item?.varImgURL;
                                                    }
                                                    return(
                                                    <SwiperSlide key={item.id} className="py-4">
                                                        <div className="items d-flex flex-column w-100 shadow">
                                                            <Link to={DetalPageUrl} className="title flex-grow-1">
                                                                <div className="thumbnail-container object-fit bg-transparent" data-thumb="39.6%">
                                                                    <div className="thumbnail">
                                                                        <img
                                                                            src={firstImage}
                                                                            alt={item?.varTitle}
                                                                            title={item?.varTitle}
                                                                            width={200}
                                                                            height={120}
                                                                            loading="lazy"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                            <div className="content d-flex flex-column flex-grow-1">
                                                                <div className="date mb-2">{formatDate(item?.dtDateTime)}</div>
                                                                <h4>
                                                                    <Link to={DetalPageUrl} className="title flex-grow-1">
                                                                        {item?.varTitle}
                                                                    </Link>
                                                                </h4>
                                                                <div>
                                                                    <Link to={DetalPageUrl} className="btn btn-primary mt-4 mt-md-5">
                                                                        READ MORE<BtnArrow />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                )})}
                                            </Swiper>
                                        </div>
                                    </Col>
                                    <Col xs={12} className="text-center mt-4">
                                        <Button title="prev" className="nav-icon custom-prev">
                                            <i className="left"><BtnArrow /></i>
                                        </Button>
                                        <Button title="Next" className="nav-icon custom-next">
                                            <i className="right"><BtnArrow /></i>
                                        </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                    )
                }
           </>
    );

}

export default NewsDetails;
